module.exports = __webpack_public_path__ + "static/img/Patty-Mills.8e13771.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patty-Mills.jpg
// module id = unTL
// module chunks = 1